import getStoreByIdQuery from './getStoreByIdQuery';
import getStoreBySellerId from './getStoreBySellerId';

const ActorService = {
  getStoreBySellerId,
  getStoreByIdQuery,
};

export default ActorService;
